import { createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "../../app/api";
import { serializeError } from "../../app/shared";
import LicenceModel from "../../models/LicenceModel";

const SLICE_NAME = 'licenceSlice';

export const getLicenceListByLocationId = createAsyncThunk(
  `${SLICE_NAME}/loadByQuery`,
  async (locationId: number, { rejectWithValue }) => {
    try {
      const { licenceList }: { licenceList: LicenceModel[] } = await request.get(`/licence`, {
        params: { locationId },
      });
      return licenceList;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  }
);

export const createLicence = createAsyncThunk(
  `${SLICE_NAME}/create`,
  async (body: unknown, { rejectWithValue }) => {
    try {
      const licence: LicenceModel = await request.post(`/licence`, body);
      return licence;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  }
);

export const updateLicence = createAsyncThunk(
  `${SLICE_NAME}/update`,
  async (body: unknown, { rejectWithValue }) => {
    try {
      const licence: LicenceModel = await request.put(`/licence`, body);
      return licence;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  }
);